import {getApiBase} from '../../env';

export const imgUrl = (url: string) => `${getApiBase()}${url}`